
<div class="flex flex-column mt-2 align-items-center justify-content-center">
  <h2 style="color: var(--secondary-500);">Excelente, encontraste lo que estabas buscando.</h2>
  <h3 style="color: var(--primary-500);">Para continuar con el proceso de solicitud, te solicitaremos unos datos mas.</h3>
  <form [formGroup]="contratarFormGroup" autocomplete="off">
    <div class="text-center">
    <mat-form-field class="text-center example-full-width">
      <mat-label>Número de {{tipo_documento}}</mat-label>
      <input matInput type="text"
      formControlName="numerodocControl"
      placeholder="Ingrese el número sin punto y sin guiones."
      id="numero_doc"
      />
      <div *ngIf="contratarFormGroup.controls['numerodocControl']?.hasError('minlength') && contratarFormGroup.controls['numerodocControl']?.touched">
        <small class="error">
          El número de {{tipo_documento}} debe tener 11 caracteres.
        </small>
      </div>
    </mat-form-field>

  </div>
  <div class="col-fixed">
    <mat-form-field class="example-full-width">
      <mat-label>Calle</mat-label>
      <input matInput type="text" formControlName="calleControl" id="calle">
    </mat-form-field>
  </div>
  <div class="col-fixed">
    <mat-form-field class="example-full-width">
      <mat-label>Altura</mat-label>
      <input matInput type="number" formControlName="altura_numeroControl" id="altura">
    </mat-form-field>
  </div>
  <!--
<div class="col-fixed" *ngIf="tipodocumento_option == 2">
<mat-form-field class="example-full-width">
  <mat-label>Categoría IVA</mat-label>
  <mat-select formControlName="ivaControl">
    <mat-option *ngFor="let item of iva" value="{{item.codigo}}">{{item.descripcion}}</mat-option>
  </mat-select>
</mat-form-field>
</div>
<div class="col-fixed" *ngIf="tipodocumento_option == 2">
<mat-form-field class="example-full-width">
  <mat-label>Condición Ingresos Brutos</mat-label>
  <mat-select formControlName="iibbControl">
    <mat-option *ngFor="let item of iibb"  value="{{item.codigo}}">
      {{item.descripcion}}
    </mat-option>
  </mat-select>
</mat-form-field>
</div>
<div class="col-fixed">
  <mat-form-field class="example-full-width">
    <mat-label>Medio de pago</mat-label>
    <mat-select formControlName="pagoControl" (selectionChange)="forma_pago_select($event)">
      <mat-option *ngFor="let item of formapago" value="{{item.id}}">
        {{item.descripcion}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="example-full-width">
          <mat-radio-group
            aria-label="Seleccione su forma de pago preferida"
            class="example-radio-group"
            formControlName="formapagoControl"
            >
            <mat-radio-button value="CBU">CBU</mat-radio-button>
            <mat-radio-button value="tarjeta">Tarjeta de Crédito</mat-radio-button>
          </mat-radio-group>
        </div>

<div class="col-fixed" *ngIf="formapago_option == 1">

  <mat-form-field class="example-full-width">
    <mat-label>Seleccione una de las tarjetas habilitadas.</mat-label>
    <mat-select formControlName="tarjetaControl" >
      <mat-option *ngFor="let item of tarjetas" value="{{item.codigo}}">
        {{item.descripcion | uppercase}}
      </mat-option>
    </mat-select>

  </mat-form-field>

  <div class="col-fixed">
  <mat-form-field class="example-full-width">
    <mat-label>Número</mat-label>
    <input matInput type="text" formControlName="numeroControl">
    <app-card-detector class="example-full-width" (cardDetected)="onCardDetected($event)"></app-card-detector>
  </mat-form-field>
  </div>
</div>
-->

<div class="text-center div_titulo">
          <label class="titulo">Seleccione su forma de <span class="verde">pago</span> preferida</label>
        </div>
        <div class="example-full-width">
          <mat-radio-group
            aria-label="Seleccione su forma de pago preferida"
            class="example-radio-group"
            formControlName="formapagoControl"
            >
            <mat-radio-button value="CBU">CBU</mat-radio-button>
            <mat-radio-button value="tarjeta">Tarjeta de Crédito</mat-radio-button>
          </mat-radio-group>
        </div>
        <div [hidden]="contratarFormGroup.get('formapagoControl')?.value !== 'tarjeta'" style="text-align: center;">
          <app-card-detector class="example-full-width" (cardDetected)="onCardDetected($event)"></app-card-detector>
        </div>
        <div [hidden]="contratarFormGroup.get('formapagoControl')?.value !== 'CBU'">
          <mat-form-field class="example-full-width">
            <mat-label>Ingrese el número de su {{contratarFormGroup.get('formapagoControl')?.value}}</mat-label>
            <input matInput type="text" formControlName="numeroControl" maxlength="22" autocomplete="new-cbu"/>
          </mat-form-field>
          <small>Las claves virtuales únicas (CVU), como ser de Brubank (cuya clave comienza con el código 143) y Mercado Pago (comienza con el código 000), no están habilitados como conducto de pago.</small>
        </div>


</form>

<button mat-button class="button-next-back" (click)="contratar()" [disabled]="contratarFormGroup.invalid" >Contratar</button>


</div>
